<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="/">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <router-link to="/mingyevip">鸣野VIP</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>课程管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索 -->
    <div class="content">
      <el-form
        inline
        :model="query"
        label-width="60px"
        label-position="right"
        size="small"
        class="query-form"
        @submit.native.prevent="getList()"
      >
        <el-form-item label="学生">
          <span style="font-weight: bold; font-size: 16px; color: #409EFF;">{{ studentName }}</span>
        </el-form-item>
        <el-form-item label="搜索">
          <el-input v-model="query.key" placeholder="请输入课程名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selList()">查询</el-button>
          <el-button type="success" @click="addClick()">新增课程</el-button>
        </el-form-item>
      </el-form>

      <!-- 主体 -->
      <el-card class="box-card table">
        <div class="clearfix" slot="header">
          <span>课程列表</span>
        </div>

        <!-- 列表 -->
        <el-table
          v-loading="loading"
          :data="tableData"
          ref="tableData"
          border
          stripe
          style="width:100%"
        >
          <el-table-column prop="studentName" label="姓名" width="100"></el-table-column>
          <el-table-column prop="courseName" label="课程名称"></el-table-column>
          <el-table-column prop="coursePrice" label="课程费用" width="100"></el-table-column>
          <el-table-column prop="payTime" label="缴费时间" width="110"></el-table-column>
          <el-table-column prop="teacherNames" label="讲师名字"></el-table-column>
          <el-table-column prop="classHour" label="课时数" width="80"></el-table-column>
          <el-table-column prop="classForm" label="上课形式" width="100"></el-table-column>
          <el-table-column prop="createTime" label="操作时间" width="150"></el-table-column>

          <!-- 操作 -->
          <el-table-column label="操作" width="100" fixed="right">
            <template slot-scope="scope">
              <el-button-group>
                <el-tooltip content="编辑" placement="top">
                  <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-edit"
                    @click="editClick(scope.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="删除" placement="top">
                  <el-button
                    type="warning"
                    size="mini"
                    icon="el-icon-delete"
                    @click="delClick(scope.row)"
                  ></el-button>
                </el-tooltip>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="block" style="margin-top:20px;">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="pageSize"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 弹框 -->
    <el-dialog :title="form.id > 0 ? '编辑课程' : '添加课程'" :visible.sync="dialogVisible">
      <el-form
        :model="form"
        ref="form"
        label-width="100px"
        :status-icon="true"
        @submit.native.prevent="submitForm()"
      >
        <el-form-item prop="courseName" label="购买课程" :rules="[{required: true, message: '不能为空'}]">
          <el-input v-model="form.courseName" placeholder="请输入课程名称"></el-input>
        </el-form-item>

        <el-form-item prop="payTime" label="缴费时间" :rules="[{required: true, message: '不能为空'}]">
          <el-date-picker
            v-model="form.payTime"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="请选择时间"
          ></el-date-picker>
        </el-form-item>

        <el-form-item prop="coursePrice" label="全额费用">
          <el-input-number v-model="form.coursePrice" :min="0" :precision="2" :step="0.01" style="width:100%"></el-input-number>
        </el-form-item>

        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item prop="amount1" label="一期">
              <el-input-number v-model="form.amount1" :min="0" :precision="2" :step="0.01" style="width:100%"></el-input-number>
            </el-form-item>
            <el-form-item prop="phase1Date" label="一期日期">
              <el-date-picker v-model="form.phase1Date" value-format="yyyy-MM-dd" type="date" placeholder="请选择日期" style="width:100%"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="amount2" label="二期">
              <el-input-number v-model="form.amount2" :min="0" :precision="2" :step="0.01" style="width:100%"></el-input-number>
            </el-form-item>
            <el-form-item prop="phase2Date" label="二期日期">
              <el-date-picker v-model="form.phase2Date" value-format="yyyy-MM-dd" type="date" placeholder="请选择日期" style="width:100%"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="amount3" label="三期">
              <el-input-number v-model="form.amount3" :min="0" :precision="2" :step="0.01" style="width:100%"></el-input-number>
            </el-form-item>
            <el-form-item prop="phase3Date" label="三期日期">
              <el-date-picker v-model="form.phase3Date" value-format="yyyy-MM-dd" type="date" placeholder="请选择日期" style="width:100%"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item prop="percentage" label="顾问提成" :rules="[{required: true, message: '不能为空'}]">
          <el-input type="number" v-model.number="form.percentage" placeholder="请输入数字"></el-input>
        </el-form-item>

        <el-form-item prop="classHour" label="课时数" :rules="[{required: true, message: '不能为空'}]">
          <el-input type="number" v-model.number="form.classHour" placeholder="请输入课时"></el-input>
        </el-form-item>

        <el-form-item label="上课形式">
          <el-select v-model="form.classForm" placeholder="请选择上课形式" style="width: 100%;">
            <el-option label="线下课" value="线下课"></el-option>
            <el-option label="网课" value="网课"></el-option>
            <el-option label="录播课" value="录播课"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="startTime" label="开始时间" :rules="[{required: true, message: '不能为空'}]">
          <el-date-picker
            v-model="form.startTime"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="请选择开始时间"
          ></el-date-picker>
        </el-form-item>

        <el-form-item prop="endTime" label="结束时间" :rules="[{required: true, message: '不能为空'}]">
          <el-date-picker
            v-model="form.endTime"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="请选择结束时间"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="教学老师">
          <el-select
            v-model="teacherOptions"
            placeholder="请选择教学老师"
            multiple
            clearable
            style="width:100%"
          >
            <el-option
              v-for="item in teacherlist"
              :label="item.realName"
              :value="item.userID"
              :key="item.userID"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="缴费类型">
          <el-radio-group v-model="form.isRenewal">
            <el-radio :label="false">新报</el-radio>
            <el-radio :label="true">续费</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit">提交</el-button>
          <el-button @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";

export default {
  name: "MingyeCourse",
  data() {
    return {
      studentID: 0,
      studentName: "",
      query: {},
      form: {},
      submiting: false,
      loading: false,
      dialogVisible: false,
      tableData: [],
      total: 0,
      pageSize: 10,
      currentPage: 1,
      teacherlist: [],
      teacherOptions: []
    };
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    // 获取学生信息
    getStudentInfo() {
      var _this = this;
      $.get(url.getStu("GetStudentModel"), { id: this.studentID }, (data) => {
        if (data && data.realName) {
          _this.studentName = data.realName;
        }
      });
    },
    // 教师
    getTeacherList() {
      var _this = this;
      var link = url.getMingye("getteacher");
      $.get(link, {}, (data) => {
        _this.teacherlist = data;
      });
    },
    // 列表
    getList() {
      var _this = this;
      _this.loading = true;
      var params = {
        studentID: _this.studentID,
        key: _this.query.key || "",
        pageSize: _this.pageSize,
        pageIndex: _this.currentPage
      };
      $.get(url.getMingye("GetList_Course"), params, (data) => {
        _this.loading = false;
        _this.tableData = data.list || [];
        _this.total = data.total || 0;
        // 从列表数据获取学生姓名
        if (data.list && data.list.length > 0 && data.list[0].studentName) {
          _this.studentName = data.list[0].studentName;
        }
      });
    },
    // 查询
    selList() {
      this.currentPage = 1;
      this.getList();
    },
    // 新增
    addClick() {
      this.form = {
        id: 0,
        studentID: this.studentID,
        courseName: "",
        payTime: "",
        coursePrice: 0,
        amount1: 0,
        amount2: 0,
        amount3: 0,
        phase1Date: null,
        phase2Date: null,
        phase3Date: null,
        percentage: 0,
        classHour: null,
        classForm: "",
        startTime: null,
        endTime: null,
        isRenewal: false
      };
      this.teacherOptions = [];
      this.dialogVisible = true;
    },
    // 编辑
    editClick(row) {
      var _this = this;
      $.get(url.getMingye("GetModel_Course"), { id: row.id }, (data) => {
        _this.form = {
          id: data.id,
          studentID: data.studentID,
          courseName: data.courseName || "",
          payTime: data.payTime || "",
          coursePrice: data.coursePrice || 0,
          amount1: data.amount1 || 0,
          amount2: data.amount2 || 0,
          amount3: data.amount3 || 0,
          phase1Date: data.phase1Date || null,
          phase2Date: data.phase2Date || null,
          phase3Date: data.phase3Date || null,
          percentage: data.percentage || 0,
          classHour: data.classHour,
          classForm: data.classForm || "",
          startTime: data.startTime || null,
          endTime: data.endTime || null,
          isRenewal: data.isRenewal || false
        };
        if (data.teachers) {
          _this.teacherOptions = data.teachers.split(",").map(Number);
        } else {
          _this.teacherOptions = [];
        }
        _this.dialogVisible = true;
      });
    },
    // 删除
    delClick(row) {
      var _this = this;
      this.$confirm("确定要删除该课程记录吗？删除后将扣减累计缴费金额。", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        $.post(url.getMingye("Delete_Course"), { id: row.id }, (res) => {
          if (res.status) {
            _this.getList();
            _this.$message({ type: "success", message: res.msg });
          } else {
            _this.$message({ type: "error", message: res.msg });
          }
        });
      }).catch(() => {
        this.$message({ type: "info", message: "已取消" });
      });
    },
    // 提交
    submitForm() {
      var _this = this;
      this.$refs.form.validate((valid) => {
        if (valid) {
          _this.submiting = true;
          var params = {
            id: _this.form.id || 0,
            studentID: _this.studentID,
            courseName: _this.form.courseName,
            coursePrice: _this.form.coursePrice || 0,
            payTime: _this.form.payTime,
            amount1: _this.form.amount1 || 0,
            amount2: _this.form.amount2 || 0,
            amount3: _this.form.amount3 || 0,
            phase1Date: _this.form.phase1Date,
            phase2Date: _this.form.phase2Date,
            phase3Date: _this.form.phase3Date,
            percentage: _this.form.percentage || 0,
            teachers: _this.teacherOptions.join(","),
            classHour: _this.form.classHour,
            classForm: _this.form.classForm,
            startTime: _this.form.startTime,
            endTime: _this.form.endTime,
            isRenewal: _this.form.isRenewal
          };
          $.post(url.getMingye("AddOrUpdate_Course"), params, (res) => {
            _this.submiting = false;
            if (res.status) {
              _this.dialogVisible = false;
              _this.getList();
              _this.$message({ type: "success", message: res.msg });
            } else {
              _this.$message({ type: "error", message: res.msg });
            }
          });
        }
      });
    }
  },
  mounted() {
    // 接收参数
    this.studentID = parseInt(this.$route.query.id) || 0;
    if (this.studentID > 0) {
      this.getStudentInfo();
      this.getTeacherList();
      this.getList();
    } else {
      this.$message({ type: "error", message: "缺少学生ID参数" });
    }
  }
};
</script>

<style scoped>
.query-form {
  margin-top: 20px;
  padding-top: 25px;
  background: #f2f2f2;
}
.el-input,
.el-select {
  width: 100%;
}
</style>
